(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("zebDshAuthentication", [], factory);
	else if(typeof exports === 'object')
		exports["zebDshAuthentication"] = factory();
	else
		root["zebDshAuthentication"] = factory();
})(self, () => {
return 